import { LoginInfoDto } from '@asset-metrix/portal-gateway-client-js';
import {
  getConfiguredLanguageCodes,
  resolvePreferredLanguage,
} from '@asset-metrix/portal-ui';

import { queryClient } from '../utils/queryClient';

export function getPortalAcceptLanguage(): string {
  const loginInfo = queryClient.getQueryData<LoginInfoDto>(['tenantLoginInfo']);
  const languages = loginInfo?.languages ?? [];

  return resolvePreferredLanguage(
    loginInfo?.localeMessages,
    languages.length > 0 ? getConfiguredLanguageCodes(languages) : undefined
  );
}
